import Swal from 'sweetalert2';

interface AlertOptions
{
    title: string,
    html: string,
    text: string,
    showDenyButton: boolean,
    denyButtonText: string,
    showCancelButton: boolean,
    cancelButtonText: string,
    confirmButtonText: string
}

/**
 * Simple Alert class to notify the user about simple updates.
 */

class Alert
{
    fire(options: AlertOptions):any
    {
        return Swal.fire(options);
    }

    notify(message: string | any, title?:string)
    {
        // fix from old way ...
        if (message.text)
        {
            message = message.text;
        }

        this.fire({
            html: message,
            title: title || ""
        } as AlertOptions)
    }

    confirm(message:string, yes:Function, no:Function):void
    {
        this.fire({
            title: "Are you sure?",
            text: message,
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonText: "Yes"
        } as AlertOptions).then((res:any) => {
            if (res.isConfirmed)
            {
                yes && yes();
                return;
            }

            no && no();
        });
    }
}

const singleton = new Alert();
export default singleton;
